import React from 'react';
import './error.css';
import { KID_1 } from '../../utils/constants/images';

function NotFoundPage() {
    return (
        <div className="error-container">
            <img src={KID_1} alt="Error" className="error-image" />
            <h1>Something went wrong</h1>
            <p>An error occured on this page. please contact Beststart helpdesk</p>
        </div>
    );
}

export default NotFoundPage;